module.exports = __webpack_public_path__ + "img/cares.dd27009f.svg";